// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"747":"06b446ff","911":"1c4dd5c2"}[chunkId] + ".chunk.js";
};